import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { TranslationService } from '@proximus/ng-common';
import { OnDestroyHookDirective } from '../shared/hooks';

@Injectable()
export class CyberCareDetailsAllowedGuard
  extends OnDestroyHookDirective
  implements CanActivate
{
  constructor(private translationService: TranslationService) {
    super();
  }

  canActivate(): boolean {
    return (
      this.translationService.getTranslatedValueFor('cybercare.allowed') ===
      'true'
    );
  }
}
